import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';

const propTypes = {
  accountFileComment: PropTypes.shape({
    created_at: PropTypes.date,
  }),
};

const RefreshingDate = ({ accountFileComment }) => {
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const timer = useRef();

  useEffect(() => {
    timer.current = setInterval(() => {
      forceUpdate();
    }, 60000);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, []);

  return (
    <>
      {formatDistanceToNow(
        new Date(accountFileComment.created_at ?? new Date().toString()),
        {
          addSuffix: true,
        },
      )}
    </>
  );
};

RefreshingDate.propTypes = propTypes;

export default RefreshingDate;
